/**
 * @desc 订单买家经销商组件
 * @description 订单类型
 * @argument 大域订单
 * @argument 自有平台订单
 * props: record  [object] //订单的信息
 */
import React, { Component } from 'react';
import { Popover } from 'antd';
import styles from './style/index.less';
import { dealValueShow } from '@/shared/functions';
import { showInfo } from '@/components';
class BuyerDistributor extends Component {
    renderData(record) {
        const content = (<div className={styles.antPopoveOpen}>
        <p>此用户为车易拍用户</p>
        <p>不可查看详细信息</p>
      </div>);
        return (<div>
        {(record.actionType === 10 && record.orderTag === 1) ? (<React.Fragment>
                <span className={styles.commonColorTitle}>买家经销商：</span>
                <Popover content={content} trigger="hover" placement="right" getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
                  <span className={styles.buyDistributor}>{dealValueShow(record.buyerName)}</span>
                </Popover>
              </React.Fragment>) :
            <a onClick={() => {
                showInfo('buyer', record.buyerCode);
            }}>
              <span className={styles.commonColorTitle}>买家经销商：</span>
              <span>{dealValueShow(record.buyerName)}</span>
            </a>}
      </div>);
    }
    render() {
        const { record } = this.props;
        return (<>
        {this.renderData(record)}
      </>);
    }
}
export default BuyerDistributor;
